import { jsxs as $, jsx as r, Fragment as I } from "react/jsx-runtime";
import { useRef as R, useEffect as N, useCallback as k } from "react";
import "../../utils/normalizeForCollation/index.js";
import "../../hooks/useInputSystem/system/constants.js";
import "../../hooks/useInputSystem/key/constants.js";
import "../../hooks/useInputSystem/provider/context.js";
import { usePrefersReducedMotion as A } from "../../hooks/usePrefersReducedMotion/index.js";
import { ax as C, ay as v, az as w, aA as B, aB as T, aC as q, aD as z } from "../../vendor-CPVnY93G.js";
import "../../theme/spacing.js";
import { omitStyleRenderProps as D } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as F } from "../BaseIcon/index.js";
import '../../assets/index55.css';const K = "_tabs_djpnu_1", M = "_tabList_djpnu_14", E = "_tab_djpnu_1", V = "_label_djpnu_55", G = "_underline_djpnu_59", H = "_selectionIndicator_djpnu_69", J = "_tabPanels_djpnu_83", O = "_tabPanel_djpnu_83", Q = "_icon_djpnu_112", n = {
  tabs: K,
  tabList: M,
  tab: E,
  label: V,
  underline: G,
  selectionIndicator: H,
  tabPanels: J,
  tabPanel: O,
  icon: Q
};
function L(a) {
  return "href" in a;
}
function U(a) {
  return a.length > 0 && L(a[0]);
}
function ce(a) {
  const { items: c, selectedKey: f, defaultSelectedKey: b, onSelectionChange: u, ...P } = a, l = R(null), j = A(), p = U(c), x = (e) => {
    if (!p)
      return {};
    if (!L(e))
      return {};
    const { target: t } = e, o = (() => {
      if (t !== "_blank")
        return e.rel;
      const s = new Set(
        (e.rel ?? "").split(/\s+/).map((i) => i.trim()).filter(Boolean)
      );
      return s.add("noopener"), s.add("noreferrer"), [...s].join(" ");
    })();
    return {
      download: e.download,
      href: e.href,
      hrefLang: e.hrefLang,
      ping: e.ping,
      referrerPolicy: e.referrerPolicy,
      rel: o,
      target: t
    };
  }, m = f ?? b, _ = (e, t) => {
    if (!e)
      return;
    const o = t === void 0 ? e.querySelector('[role="tab"][data-selected]') : Array.from(e.querySelectorAll('[role="tab"]')).find(
      (y) => y.getAttribute("data-key") === String(t)
    );
    if (!o)
      return;
    const s = e.getBoundingClientRect(), i = o.getBoundingClientRect(), h = i.left - s.left, g = i.right - s.right;
    let d = e.scrollLeft;
    if (h < 0)
      d += h;
    else if (g > 0)
      d += g;
    else
      return;
    e.scrollTo({
      behavior: j ? "auto" : "smooth",
      left: d
    });
  };
  N(() => {
    requestAnimationFrame(() => _(l.current, m));
  }, [m]);
  const S = k(
    (e) => {
      u?.(e), requestAnimationFrame(() => _(l.current, e));
    },
    [u]
  );
  return c.length === 0 ? null : /* @__PURE__ */ $(
    C,
    {
      ...D(P),
      className: n.tabs,
      orientation: "horizontal",
      keyboardActivation: "automatic",
      selectedKey: f,
      defaultSelectedKey: b,
      onSelectionChange: S,
      children: [
        /* @__PURE__ */ r(
          v,
          {
            ref: l,
            "aria-label": a["aria-label"],
            items: c,
            className: n.tabList,
            children: (e) => {
              const t = e;
              return /* @__PURE__ */ r(
                w,
                {
                  id: t.id,
                  isDisabled: t.isDisabled,
                  className: n.tab,
                  ...x(t),
                  children: B(e.label, (o) => /* @__PURE__ */ $(I, { children: [
                    e.startIcon && /* @__PURE__ */ r(F, { icon: e.startIcon, size: "sm", className: n.icon }),
                    /* @__PURE__ */ r("span", { className: n.label, children: o }),
                    /* @__PURE__ */ r(z, { className: n.selectionIndicator })
                  ] }))
                }
              );
            }
          }
        ),
        /* @__PURE__ */ r("div", { className: n.underline }),
        !p && /* @__PURE__ */ r(T, { items: c, className: n.tabPanels, children: (e) => /* @__PURE__ */ r(q, { id: e.id, className: n.tabPanel, children: e.content }) })
      ]
    }
  );
}
export {
  ce as Tabs
};
